import { createApi, retry } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'modules/api/utils';

import type { MemberTagsMap, TagDemographic, TagFilter } from './types';

export const tagsApi = createApi({
  reducerPath: 'tagsApi',
  baseQuery: retry(axiosBaseQuery(), { maxRetries: 0 }),
  endpoints: (builder) => ({
    getDemographics: builder.query<TagDemographic[], { reportId: number; filters?: TagFilter[] }>({
      query: ({ reportId, filters }) => ({
        url: '/tags/demographics',
        method: 'POST',
        data: { reportId, filters: filters ?? [] },
      }),
    }),
    filterMembers: builder.mutation<number[], { communityId: number; filters: TagFilter[] }>({
      query: ({ communityId, filters }) => ({
        url: '/tags/filter-members',
        params: { communityId },
        method: 'POST',
        data: { filters },
      }),
    }),
    getMemberTags: builder.query<MemberTagsMap, { communityId: number; memberIds: number[] }>({
      query: ({ communityId, memberIds }) => ({
        url: '/tags/members',
        params: { communityId },
        method: 'POST',
        data: { memberIds },
      }),
    }),
  }),
});

export const { useGetDemographicsQuery, useFilterMembersMutation, useGetMemberTagsQuery } = tagsApi;
